import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import FooterAction from './components/FooterAction';
import UpdateAppointmentButton from './components/UpdateAppointmentButton';

export default function ChildComponent() {
  const [footerNode, setFooterNode] = useState(null);

  useEffect(() => {
    const node = document.getElementById('footer-actions');
    if (node) {
      setFooterNode(node);
    }
  }, []);

  return footerNode
    ? ReactDOM.createPortal(
        <div className="flex items-center ">
          <FooterAction handleClose={() => {}} />
          <UpdateAppointmentButton />
        </div>,
        footerNode
      )
    : null;
}
